import React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import classnames from 'classnames';

import Image from 'components/Image';
import { IChallenge } from "types/storylet";

const SECOND_CHANCE_ICONS = {
  Dangerous: 'fist',
  Persuasive: 'confidentsmile',
  Shadowy: 'blackglove',
  Watchful: 'eye',
};

export interface Props {
  data: IChallenge,
  locked: boolean,
  toggleSecondChance: (_: boolean, __: number) => void,
}

class SecondChance extends React.Component<Props & RouteComponentProps & DispatchProp> {
  static displayName = 'SecondChance';

  handleChange = (e: any) => {
    const { toggleSecondChance, data } = this.props;
    toggleSecondChance(e.target.checked, data.secondChanceId);
  };

  render() {
    const { data, locked } = this.props;
    const {
      id,
      name,
      secondChanceDescription,
      secondChanceLevel,
    } = data;

    return (
      <div className={classnames('second-chance', locked && 'second-chance--locked')}>
        <div className="second-chance__left">
          <div className="icon second-chance__icon">
            <Image
              icon={SECOND_CHANCE_ICONS[name]}
              type="small-icon"
            />
            <div className="icon__value">
              {secondChanceLevel}
            </div>
          </div>
        </div>
        <div className="second-chance__body">
          <label htmlFor={`js-second-chance-${id}`}>
            <input
              className="second-chance__checkbox"
              id={`js-second-chance-${id}`}
              name="secondChances"
              type="checkbox"
              onChange={this.handleChange}
            />
            <span
              dangerouslySetInnerHTML={{ __html: secondChanceDescription }}
            />
          </label>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(SecondChance));
